import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replace'
})
export class ReplacePipe implements PipeTransform {

  transform(value: any, strToReplace: string, replacementStr: string): any {
    let result = value.replace(strToReplace, replacementStr)
    return result;
  }

}
